"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clonePrimitive = exports.sanitize = void 0;
const tslib_1 = require("tslib");
const fast_copy_1 = tslib_1.__importDefault(require("fast-copy"));
/**
 * Recursively sanitizes anything.
 */
const sanitize = (obj, options) => {
    var _a, _b;
    const filterFns = [];
    if (options.removeNully) {
        filterFns.push((v) => v != null);
    }
    if (((_b = (_a = options.removeProps) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0) {
        filterFns.push((_v, k) => { var _a; return Boolean((_a = options.removeProps) === null || _a === void 0 ? void 0 : _a.every((prop) => prop !== k)); });
    }
    if (Array.isArray(obj)) {
        return obj
            .filter((v, k) => filterFns.every((filterFn) => filterFn(v, k)))
            .reduce((acc, v) => [...acc, v === Object(v) ? (0, exports.sanitize)(v, options) : v], []);
    }
    if (ArrayBuffer.isView(obj)) {
        return obj;
    }
    if (typeof obj === 'object' && obj) {
        return Object.entries(obj)
            .filter(([k, v]) => filterFns.every((filterFn) => filterFn(v, k)))
            .reduce((acc, [k, v]) => (Object.assign(Object.assign({}, acc), { [k]: v === Object(v) ? (0, exports.sanitize)(v, options) : v })), {});
    }
    return obj;
};
exports.sanitize = sanitize;
const clonePrimitive = (obj, options = { removeNully: false }) => {
    const anythingToSanitize = Object.values(options).some((o) => o);
    const toClone = anythingToSanitize ? (0, exports.sanitize)(obj, options) : obj;
    return (0, fast_copy_1.default)(toClone);
};
exports.clonePrimitive = clonePrimitive;
//# sourceMappingURL=clone.js.map